import { useSyncExternalStore } from 'react';

// Texto do design system — o único ponto por onde a biblioteca partilhada fala.
// A app (lean/HQ) liga o seu catálogo com `setDsResolver`; sem resolver, ficam os
// textos pt de origem. Assim o pacote não depende de nenhuma biblioteca i18n.
type Vars = Record<string, string | number>;
type Resolver = (key: string, fallback: string, vars?: Vars) => string;

let resolver: Resolver | null = null;
let version = 0;
const listeners = new Set<() => void>();

/** Liga (ou troca) o resolvedor de textos e re-renderiza quem usa `useDs()`. */
export function setDsResolver(r: Resolver | null) {
  resolver = r;
  version++;
  listeners.forEach((l) => l());
}

const fill = (s: string, vars?: Vars) =>
  vars ? s.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => String(vars[k] ?? '')) : s;

/** Texto traduzido; `fallback` é o pt de origem (também com `{{var}}`). */
export function ds(key: string, fallback: string, vars?: Vars): string {
  return resolver ? resolver(key, fallback, vars) : fill(fallback, vars);
}

/** Subscreve mudanças de idioma: usar em componentes que chamam `ds()`. */
export function useDs() {
  useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => version,
    () => version,
  );
  return ds;
}
